import styled from 'styled-components'

import { bordergray, inputgray, darkgray } from '../../../styles/colors'

export const Intro = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
  border-bottom: 1px solid ${bordergray};
`

export const IntroContent = styled.div`
  width: calc(100% - 75px);
  padding-left: 1.5rem;
`

export const IntroIconContainer = styled.div`
  width: 75px;
  height: 75px;
`

export const IntroTitle = styled.div`
  font-size: 16px;
  line-height: 1.5;
  color: ${darkgray};
`

export const IntroSubtitle = styled.div`
  margin-top: .5rem;
  font-size: 16px;
  color: ${inputgray};
`


// WEBPACK FOOTER //
// ./src/components/MobileHeader/UserMenuDropdown/styles.js